import React, { useState, useEffect } from 'react';
import { mediaService } from '../services/mediaService';
import { supabase } from '../supabaseClient';
import './VideoSidebar.css';
import { FaLinkedinIn, FaInstagram, FaXTwitter, FaFacebookF } from 'react-icons/fa6';

function VideoSidebar() {
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [isHomePage, setIsHomePage] = useState(
    window.location.hash === '' || window.location.hash === '#accueil' || window.location.hash === '#'
  );

  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash.split('?')[0];
      setIsHomePage(hash === '' || hash === '#accueil' || hash === '#');
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

  useEffect(() => {
    loadVideos();
  }, []);

  const loadVideos = async () => {
    try {
      const { data: activeEdition } = await supabase
        .from('editions')
        .select('year')
        .eq('is_active', true)
        .single();
      
      let editionYear = '2025';
      if (activeEdition) {
        editionYear = activeEdition.year;
      }

      const videoData = await mediaService.getMediaData(editionYear);
      setVideos(videoData || []);
    } catch (error) {
    }
  };

  if (videos.length === 0 && !isHomePage) return null;

  // For looping, we clone the list
  const displayVideos = videos.length > 5 ? [...videos, ...videos] : videos;

  return (
    <>
      {isHomePage && (
        <div className="social-sidebar">
          <a href="https://www.linkedin.com/in/congr%C3%A8s-international-gsida-965b9a35a/?trk=public_post_feed-actor-name&originalSubdomain=ma" target="_blank" rel="noopener noreferrer" className="social-icon linkedin" title="LinkedIn">
            <FaLinkedinIn />
          </a>
          <a href="https://www.instagram.com/accounts/login/?next=%2Fcigsida2025%2F&source=omni_redirect" target="_blank" rel="noopener noreferrer" className="social-icon instagram" title="Instagram">
            <FaInstagram />
          </a>
          <a href="https://x.com/cigsida2025" target="_blank" rel="noopener noreferrer" className="social-icon twitter" title="X (Twitter)">
            <FaXTwitter />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61575151404825" target="_blank" rel="noopener noreferrer" className="social-icon facebook" title="Facebook">
            <FaFacebookF />
          </a>
        </div>
      )}

      {videos.length > 0 && (
      <div className="video-sidebar">
        <div className="scroller-viewport">
          <div className={`video-scroller ${videos.length > 5 ? 'is-scrolling' : ''}`}>
            {displayVideos.map((video, idx) => (
              <div key={`${video.id}-${idx}`} className="sidebar-thumbnail" onClick={() => setSelectedVideo(video)}>
                <img 
                  src={video.thumbnail || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNDAwIDMwMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI0YzRjRGNiIvPjxwYXRoIGQ9Ik0xNzUgMTI1SDIyNVYxNzVIMTc1VjEyNVoiIGZpbGw9IiM5QzlDOTkiLz48dGV4dCB4PSIyMDAiIHk9IjIyMCIgZm9udC1mYW1pbHk9InN5c3RlbS11aSIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzlDOUM5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSI+Vmlkw6lvIG5vbiBkaXNwb25pYmxlPC90ZXh0Pjwvc3ZnPg=='} 
                  alt={video.title} 
                  title={video.title}
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNDAwIDMwMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI0YzRjRGNiIvPjxwYXRoIGQ9Ik0xNzUgMTI1SDIyNVYxNzVIMTc1VjEyNVoiIGZpbGw9IiM5QzlDOTkiLz48dGV4dCB4PSIyMDAiIHk9IjIyMCIgZm9udC1mYW1pbHk9InN5c3RlbS11aSIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzlDOUM5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSI+Vmlkw6lvIG5vbiBkaXNwb25pYmxlPC90ZXh0Pjwvc3ZnPg==';
                  }}
                />
                <div className="sidebar-play-icon">▶</div>
              </div>
            ))}
          </div>
        </div>
        <a href="#media" className="see-more-button">Voir plus</a>
      </div>
      )}

      {selectedVideo && (
        <div className="sidebar-video-modal" onClick={() => setSelectedVideo(null)}>
          <div className="sidebar-modal-content" onClick={e => e.stopPropagation()}>
            <button className="sidebar-close-button" onClick={() => setSelectedVideo(null)}>×</button>
            <div className="sidebar-video-player">
              <iframe
                src={selectedVideo.videoUrl}
                title={selectedVideo.title}
                frameBorder="0"
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
            <div className="sidebar-video-details">
              <h2>{selectedVideo.title}</h2>
              <p>{selectedVideo.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VideoSidebar;
